import { useEffect, useRef, useState } from 'react';

export const useStateWithDeferredHandling = ({
  value,
  handler,
  delay = 500,
}) => {
  const [_value, setValue] = useState(value);

  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  const delayRef = useRef(delay);
  delayRef.current = delay;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      handlerRef.current(_value);
    }, delayRef.current);

    return () => clearTimeout(timeoutId);
  }, [_value]);

  useEffect(() => {
    setValue((prev) => (prev !== value ? value : prev));
  }, [value]);

  return [_value, setValue];
};
